// extracted by mini-css-extract-plugin
export default {"background_pic":"ClueDetail_background_pic__5UNH4"};